import { Footer } from "../../../layout/Footer";
import { SignUpButton, StoreButtons } from "./Buttons";
import { Section } from "./Section";

export const Closing = () => (
  <>
    <Section class="text-center bg-gradient-to-br from-blue-600 to-purple-700 text-white">
      <h2 class="text-3xl md:text-4xl font-bold tracking-tight">Something good to read is always a tap away.</h2>
      <p class="mt-3 text-lg text-white/85">An account is free forever, with no limits.</p>
      <div class="mt-7 flex justify-center">
        <SignUpButton label="Create a free account" testId="sign-up-landing" />
      </div>
      <p class="mt-8 mb-3 text-sm text-white/75">Prefer an app?</p>
      <StoreButtons testId="landing-closing" />
    </Section>
    <div class="max-w-5xl mx-auto w-full px-4 py-10">
      <Footer />
    </div>
  </>
);
